"use strict";
/**
 * components
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * modules
 */
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var reactstrap_1 = require("reactstrap");
var HistoryUprcIcon = /** @class */ (function (_super) {
    __extends(HistoryUprcIcon, _super);
    function HistoryUprcIcon(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState(function (prevState) { return ({ tooltipOpen: !prevState.tooltipOpen }); });
        };
        _this.state = {
            tooltipOpen: false
        };
        _this.tooltipTargetRef = React.createRef();
        return _this;
    }
    HistoryUprcIcon.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { ref: this.tooltipTargetRef },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faExclamationCircle, className: "text-danger" })),
            React.createElement(reactstrap_1.Tooltip, { placement: "bottom", isOpen: this.state.tooltipOpen, target: this.tooltipTargetRef, toggle: this.toggle }, this.props.uprc)));
    };
    return HistoryUprcIcon;
}(React.Component));
exports.HistoryUprcIcon = HistoryUprcIcon;
//# sourceMappingURL=HistoryUprcIcon.js.map